import SocialMediaMarketing from "../components/pages/SocialMediaMarketing";

export default function SocialMediaMarketingPage() {
  return <SocialMediaMarketing />;
}